import "./index.css";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ChangeCompanyDetails } from "@/components/ChangeCompany/ChangeCompanyDetails";
import { useCompanyDetails } from "@/hooks/useCompanyDetails";
import type { IContractingCompany } from "@/types/companies-contractors";
import type { ILender } from "@/types/companies-lenders";
import type { ICompanyChangeRequest } from "@/types/company-change-request";
import { Button, Modal } from "@/ui-kit";

type IProps = {
  companyType: "contractor" | "lender";
  currentCompany: ILender | IContractingCompany;
  request: ICompanyChangeRequest;
  onDismiss: () => void;
};

export const ChangeCompanyFormUser = ({
  companyType,
  request,
  currentCompany,
  onDismiss,
}: IProps) => {
  const { t } = useTranslation();

  const {
    data: newCompany,
    loading: newCompanyLoading,
    getCompanyDetails: getNewCompanyDetails,
  } = useCompanyDetails();

  useEffect(() => {
    if (!request.requestedCompanyId) {
      return;
    }

    void getNewCompanyDetails({
      id: request.requestedCompanyId,
      companyType,
    });
  }, [companyType, getNewCompanyDetails, request.requestedCompanyId]);

  return (
    <Modal
      open={true}
      onOpenChange={onDismiss}
      className="change-company__modal"
    >
      <Modal.Header title={t("label.changeCompany.label")} />
      <Modal.Body>
        <ChangeCompanyDetails
          request={request}
          currentCompany={currentCompany}
          newCompany={newCompany}
          newCompanyLoading={newCompanyLoading}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onDismiss} variant="ghost" color="neutral">
          {t("action.done")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
